// Page shell. Two modes:
//
//   default   — contentLeft | main | contentRight across a 4-column grid, with
//               main taking the middle 2. This is what every content page uses
//               and what their copy/forms are sized for, so it is left exactly
//               as it was.
//
//   fullBleed — no side columns; main owns all 4 and becomes a flex column so
//               its content can stretch to the full viewport height.
//
// fullBleed is opt-in rather than inferred from empty side props: every caller
// happens to pass contentLeft={null} contentRight={null}, so inferring it would
// silently restyle every page in the app. The admin panel asks for it because
// its screens are dense tables — at the default width the users table was
// clipped, taking the only "Reset 2FA" entry point off-screen with it.
export default function Main({
  main,
  contentLeft,
  contentRight,
  fullBleed = false,
}) {
  if (fullBleed) {
    return (
      <div className="grid pb-20 sm:grid-cols-1 lg:grid-cols-4 bg-white min-h-screen">
        <div className="lg:col-span-4 flex flex-col">{main}</div>
      </div>
    );
  }

  return (
    <>
      <div
        className={`grid pb-20 sm:grid-cols-1 lg:grid-cols-4 bg-white min-h-screen`}
      >
        <div className="hidden lg:block max-w-lg m-8">{contentLeft}</div>
        <div className="lg:col-span-2">{main}</div>
        <div className="hidden lg:block max-w-lg">{contentRight}</div>
      </div>
    </>
  );
}
